import React, { useContext, useEffect, useState, useCallback } from 'react';
import { useAppDispatch } from 'store';
import showPopupOperation from 'store/app/operation/showPopupOperation';
import { useTranslation } from 'react-i18next';
import { AvailablePopups } from 'store/app/types';
import OpIcon from 'components/Common/op-ui-wrappers/OpIcon/OpIcon';
import OpText from 'components/Common/op-ui-wrappers/OpText/OpText';
import { useSelector } from 'react-redux';
import AttributeSelectorPlacementContext, {
  AttributeSelectorPlacement,
} from 'context/ProductAttributesPlacementContext';
import getDesignProductSizeGuideImage from 'store/product/selector/getDesignProductSizeGuideImage';
import Drawer from 'components/Common/Drawer/Drawer';
import getHashFromPath from 'utils/getHashFromPath';
import cleanupLocationHash from 'utils/cleanupLocationHash';
import { SizeGuideImage } from '../SizeGuidePopup/SizeGuidePopup';
import styles from './SizeGuideTrigger.module.scss';

const SELECTOR_HASH = '#size-guide';

const SizeGuideTrigger = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [showDrawer, setShowDrawer] = useState(false);

  const placementContext = useContext(AttributeSelectorPlacementContext);
  const controlInsidePopup = placementContext === AttributeSelectorPlacement.POPUP;

  const productSizeImage = useSelector(getDesignProductSizeGuideImage);

  const hideDrawer = () => {
    setShowDrawer(false);
  };

  const onHashChange = useCallback(
    (e: any) => {
      if (getHashFromPath(e.oldURL) === SELECTOR_HASH) {
        hideDrawer();
      }
    },
    [hideDrawer],
  );

  useEffect(() => {
    if (showDrawer) {
      window.location.hash = SELECTOR_HASH;
      window.addEventListener('hashchange', onHashChange);
      return () => {
        window.removeEventListener('hashchange', onHashChange);
        cleanupLocationHash(SELECTOR_HASH);
      };
    }
    return () => {};
  }, [showDrawer]);

  if (!productSizeImage) {
    return null;
  }

  const onSizeGuideClick = () => {
    if (!controlInsidePopup) {
      dispatch(showPopupOperation(AvailablePopups.sizeGuidePopup));
    } else {
      setShowDrawer(true);
    }
  };

  return (
    <>
      <div onClick={onSizeGuideClick} className={styles.sizeGuideTrigger}>
        <OpIcon icon="ruler" size="small" />
        <OpText variant="body-medium-bold" color="primary-90">
          {t('txt_size_guide')}
        </OpText>
      </div>
      {showDrawer && (
        <Drawer closeIconInContent contentClassName={styles.drawerContent} onClose={hideDrawer}>
          <div className={styles.drawerContentWrapper}>
            <SizeGuideImage productSizeGuideImage={productSizeImage} />
          </div>
        </Drawer>
      )}
    </>
  );
};

export default SizeGuideTrigger;
